// @flow
'use strict';

import { connect } from 'react-redux';

import ProdutoServico from './produto_servico';

export default connect<*, *, *, *, *, *>()(ProdutoServico);
